// src/themes/ocean.ts
import { Theme } from "./types";

export const oceanTheme: Theme = {
  "background-light": "15 23 42", // #0F172A - Deep ocean blue
  "background-dark": "12 19 35", // #0C1323 - Darker ocean
  "card-light": "30 41 59", // #1E293B - Ocean card
  "card-dark": "25 34 52", // #192234 - Darker card
  "input-light": "51 65 85", // #334155 - Ocean input
  "input-dark": "45 58 78", // #2D3A4E - Darker input
  "border-light": "71 85 105", // #475569 - Ocean border
  "border-dark": "65 79 99", // #414F63 - Darker border
  primary: "56 189 248", // #38BDF8 - Bright ocean blue
  "primary-hover": "14 165 233", // #0EA5E9 - Deeper ocean blue
  text: "248 250 252", // #F8FAFC - Bright white text
  "text-dark": "241 245 249", // #F1F5F9 - Slightly darker text
  "text-secondary": "203 213 225", // #CBD5E1 - Soft blue-gray
  "text-secondary-dark": "148 163 184", // #94A3B8 - Muted blue-gray
};
